import TransactionModal from "./transactionModal.js";
import { trans } from "../globalFunctions.js";

export default class AddInvestmentModal extends TransactionModal {
  constructor(companyId) {
    super("add-investment-modal", companyId);
    this.$currencySelect = this.$form.querySelector('[name="currency"]');
    this.$price = this.$form.querySelector('[name="price"]');
    this.$investment = this.$form.querySelector('[name="investment"]');
    this.$shares = this.$form.querySelector('[name="shares"]');
    this.$valuation = this.$form.querySelector('[name="valuation"]');
    this.$ownership = this.$form.querySelector('[name="ownership"]');
    this.$totalShares = document.getElementById("total-shares");
    this.$pricePerShare = document.getElementById("price-per-share");
    this.pricePerShare = 1;
    this.autocompleteShares = true;

    this.formFields = [
      {
        name: "id",
        varType: "int",
      },
      {
        name: "company_name",
        varType: "string",
        required: true,
      },
      {
        name: "round",
        varType: "string",
        required: true,
      },
      {
        name: "investment",
        varType: "float",
        required: true,
      },
      {
        name: "date",
        varType: "string",
        required: true,
      },
      {
        name: "currency",
        varType: "string",
        required: true,
      },
      {
        name: "shares",
        varType: "int",
        required: true,
      },
      {
        name: "ownership",
        varType: "float",
        required: true,
      },
      {
        name: "valuation",
        varType: "float",
        required: true,
      },
      {
        name: "representative_email",
      },
      {
        name: "representative_name",
      },
    ];
    this.setupForm();
    this.setupListeners();

    this.setupCurrency().then(() => {
      this.$currencySelect.value = "EUR"; // set it as default value
      this.updateShownCurrencies();
      this.whenReady();
    });
  }

  setupListeners() {
    this.getModal()
      .querySelector('[data-action="add-investments"]')
      .addEventListener("click", () => {
        if (typeof peque.bulkInvestmentsModal === "undefined") {
          peque.bulkInvestmentsModal = new BulkInvestmentsModal();
        }
        this.hide();
        peque.bulkInvestmentsModal.show();
        setTimeout(() => {
          document.body.classList.add("modal-open");
        }, 600);
      });
  }

  setupForm() {
    this.$form.querySelector('[name="date"]').valueAsDate = new Date();

    this.$currencySelect.addEventListener("change", () => {
      this.updateShownCurrencies();
    });

    this.$investment.addEventListener("input", () => {
      this.calculateData();
    });

    this.$shares.addEventListener("input", () => {
      this.autocompleteShares = false;
      this.calculateData();
    });

    this.$valuation.addEventListener("input", () => {
      this.calculateData();
    });
  }

  getCurrency() {
    return this.$currencySelect.value;
  }

  calculateData() {
    this.calculatePricePerShare();
    const totalShares = this.calculateTotalShares();
    this.calculateOwnership(totalShares);
  }

  calculateOwnership(totalShares) {
    const ownership = (this.getInt("shares") * 100) / totalShares;
    this.$ownership.value = ownership;
    document.getElementById("ownership").innerText =
      peque.formatNumber(ownership) + "%";
  }

  calculatePricePerShare() {
    this.pricePerShare = (
      this.getFloat("investment") / this.getInt("shares")
    ).toFixed(2);
    if (isNaN(this.pricePerShare) || !isFinite(this.pricePerShare)) {
      this.pricePerShare = 1;
    }
    this.$pricePerShare.innerText =
      peque.formatNumber(this.pricePerShare) + " " + this.getCurrency();
  }

  calculateTotalShares() {
    const total = this.getFloat("valuation") / this.pricePerShare;

    if (!isNaN(total)) {
      this.$totalShares.innerText = peque.formatNumber(total);
      return total;
    }
    return this.getInt("shares");
  }

  updateShownCurrencies() {
    this.$form.querySelectorAll("[data-selected-currency]").forEach((el) => {
      el.innerText = this.$currencySelect.value;
    });
  }

  setupCurrency() {
    return new Promise((resolve, reject) => {
      peque.api("currencies").then((response) => {
        const total = response.result.length - 1;

        response.result.forEach((entry, i) => {
          const el = document.createElement("option");
          el.innerText = entry.iso;
          el.value = entry.iso;
          el.dataset.type = entry.iso;
          this.$currencySelect.appendChild(el);

          if (i === total) {
            new AutocompleteSelect(this.$currencySelect, {
              inputClasses: ["form-control"],
              dropdownClasses: ["border"],
            });
            this.$currencySelect.parentElement.classList.add("w-25");
            resolve();
          }
        });
      });
    });
  }

  validateAndSendForm() {
    this.enableSubmitButton(false);

    this.getFields(this.formFields)
      .then((data) => {
        if (data.ownership >= 100) {
          peque.navigation.showError(trans("invalid_company_ownership"));
          this.enableSubmitButton(true);
          return;
        }

        peque
          .api(
            "investments",
            JSON.stringify({
              investments: [data],
            }),
            "post"
          )
          .then((response) => {
            location.reload();
          })
          .catch((error) => {
            this.enableSubmitButton(true);

            switch (error.error) {
              case peque.ERROR_INVALID_DATA:
                if (error.field) {
                  this.showErrorOnField(
                    error.result,
                    this.$form.querySelector('[name="' + error.field + '"]')
                  );
                }
                break;
              case peque.ERROR_DUPLICATED_ENTRY:
                peque.navigation.showError(trans("duplicated_company_name"));
                break;
            }
          });
      })
      .catch((error) => {
        this.enableSubmitButton(true);
        if (typeof error.el === "undefined") {
          throw error;
        }
        this.showErrorOnField(error.message, error.el);
      });
  }
}

// window.AddInvestmentModal = AddInvestmentModal;
